/**
 * @graph-stack web-design-system
 * @graph-domain UX
 * @graph-business ロゴコンポーネント。紫グラデーション背景にAIスパークルSVGアイコンを3段階サイズで表示
 * @graph-connects none
 */
import { cn } from '../../../lib/cn';

export interface LogoProps {
  /** サイズ */
  size?: 'sm' | 'md' | 'lg';
  /** クラス名 */
  className?: string;
}

/** @graph-connects none */
const sizeStyles = {
  sm: 'w-8 h-8',
  md: 'w-12 h-12',
  lg: 'w-16 h-16',
};

/** @graph-connects none */
const iconSizeStyles = {
  sm: 'w-5 h-5',
  md: 'w-8 h-8',
  lg: 'w-10 h-10',
};

/** @graph-connects none */
export function Logo({ size = 'md', className }: LogoProps) {
  return (
    <div
      className={cn(
        'rounded-xl bg-gradient-to-br from-violet-500 via-purple-500 to-fuchsia-500 flex items-center justify-center shadow-lg shadow-purple-500/20',
        sizeStyles[size],
        className,
      )}
    >
      <svg
        className={cn(iconSizeStyles[size], 'text-white')}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* AI Sparkle / Magic icon */}
        <path
          d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z"
          fill="currentColor"
        />
        <path
          d="M19 15L19.75 17.25L22 18L19.75 18.75L19 21L18.25 18.75L16 18L18.25 17.25L19 15Z"
          fill="currentColor"
          opacity="0.7"
        />
        <path
          d="M5 15L5.5 16.5L7 17L5.5 17.5L5 19L4.5 17.5L3 17L4.5 16.5L5 15Z"
          fill="currentColor"
          opacity="0.5"
        />
      </svg>
    </div>
  );
}
